export const ERROR_MESSAGES_RESPONSE = {
  '400_ARGUMENT_IS_NOT_VALID': true,
  '400_MENU_NOT_EXISTED': true,
  '400_PRODUCT_NOT_FOUND': true,
  '404_PRODUCT_NOT_FOUND': true,
  '400_CAN_NOT_ACCESS_DATA': true,
  '404_NOTIFY_NOT_FOUND': true,
  '400_DETAIL_NOT_EXISTED': true,
};
